import API from 'utils/API'
import config from 'app/config'

export const fetchPartners = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/partner${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createPartner = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/partner', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchPartnerDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/partner/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updatePartner = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/partner/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const deletePartner = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/partner/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const webFetchPartners = params => (
  () => new Promise((resolve, reject) => (
    API.get(
      `/web/partner${params || ''}`,
      { headers: { Authorization: `Bearer ${config.api_key}` } },
    ).then(
      (response) => {
        const { data, message } = response?.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
